import { render, staticRenderFns } from "./ClickToSelectList.vue?vue&type=template&id=5a4dd700&"
import script from "./ClickToSelectList.vue?vue&type=script&lang=ts&"
export * from "./ClickToSelectList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports